import React from 'react';

function UpdateDatabase({ handleFileUpload, uploading }) {
  return (
    <section>
      <h2>Subir Archivos de Base de Datos</h2>
      <p className="section-intro">Sube los archivos en su respectivo campo para iniciar un proceso de actualización.</p>
      <div className="upload-grid">
        <div className="file-input-wrapper">
          <label htmlFor="masterFile">Archivo de Referencias (Items)</label>
          <input
            type="file"
            id="masterFile"
            accept=".xlsx"
            onChange={(e) => handleFileUpload('master', e)}
            disabled={!!uploading}
          />
        </div>
        <div className="file-input-wrapper">
          <label htmlFor="inventoryFile">Archivo de Inventario</label>
          <input
            type="file"
            id="inventoryFile"
            accept=".xlsx"
            onChange={(e) => handleFileUpload('inventory', e)}
            disabled={!!uploading}
          />
        </div>
        <div className="file-input-wrapper">
          <label htmlFor="pricesFile">Archivo de Precios</label>
          <input
            type="file"
            id="pricesFile"
            accept=".xlsx"
            onChange={(e) => handleFileUpload('prices', e)}
            disabled={!!uploading}
          />
        </div>
      </div>
      {uploading && (
        <div className="spinner-wrapper">
          <div className="spinner"></div>
          <p>Procesando {uploading}...</p>
        </div>
      )}
    </section>
  );
}

export default UpdateDatabase;